module.exports = __webpack_public_path__ + "dash_20_app_assets/img/invites.0168364f.png";